export const VERSIONS = {
  GCF_COMPONENTS_EPIC_515_VERSION: '2.0.0',
  GCF_COMPONENTS_RELEASE_25: '2.8.6',
};
